export const updateUrlParameter = (key: string, value: string) => {
  const origUrl = window.location.href;
  window.history.replaceState('', '', updateParam(origUrl, key, value));
};

const updateParam = (url: string, param: string, value: string) => {
  const re = new RegExp(param + '(.+?)(&|$)', 'g');

  if (!url.match(re)) {
    return url + (url.match('\\?') ? '&' : '?') + param + '=' + value;
  }

  return url.replace(re, param + '=' + value + '$2');
};

export const ensureTrailingSlash = (url: string) =>
  url.endsWith('/') ? url : `${url}/`;

export const setUrlParams = (
  url: URL | string,
  params: Record<string, string>
) => {
  const _url = typeof url === 'string' ? new URL(url) : url;

  Object.entries(params).forEach(([key, value]) =>
    _url.searchParams.set(key, value)
  );

  return _url;
};

// getLocalUrlFromFile - Overloading (differentiating response types)
export function getLocalUrlFromFile(file: Blob): string;
export function getLocalUrlFromFile(
  file: Blob | null | undefined
): string | null;
export function getLocalUrlFromFile(
  file: Blob | null | undefined,
  fallback: string
): string;
export function getLocalUrlFromFile(
  file: Blob | null | undefined,
  fallback?: string | null
): string | null;

// getLocalUrlFromFile - Implementation
export function getLocalUrlFromFile(
  file?: Blob | null,
  fallback?: string | null
): string | null {
  return file ? URL.createObjectURL(file) : (fallback ?? null);
}

/**
 * Strips the active market path prefix off a pathname. Mirrors getAccountBase()
 * in accountUrls.ts, which prepends window.Shopify.routes.root when building a
 * URL -- this is the missing half for the reverse direction, matching a pathname
 * (e.g. window.location.pathname) against root-relative literals. Six of seven
 * stores (and all local dev environments) run with root === '/', where the
 * pathname must come back completely unchanged.
 */
export const stripMarketPathPrefix = (pathname: string): string => {
  const root = window.Shopify?.routes?.root ?? '/';

  if (root === '/') return pathname;

  const prefix = root.replace(/\/$/, '');

  if (pathname === prefix) return '/';

  // Trailing slash enforces a segment boundary, so e.g. "/english-patterns" isn't mistaken for a "/en"-prefixed path
  if (!pathname.startsWith(`${prefix}/`)) return pathname;

  return pathname.slice(prefix.length);
};

/**
 * Helper function to create URL-friendly slug from text
 */
export const slugify = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/[\s_-]+/g, '-') // Replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
};
